import { DefaultApi } from '../../generated/api';
import configuration from './configuration';

export default new DefaultApi(configuration);
